import {GenericService, ResultType} from '@/shared/xhttp';
import {EssenceAchat, Livraison, Vente} from '@/models';

export class LivraisonService extends GenericService<Livraison> {

	public getTotauxLivraisons(totalParDepot: boolean, totalParBoisType: boolean, totalParLongueur: boolean, totalDateDebut: string, totalDateFin: string): Promise<ResultType<Livraison>> {
		return super.getC(`/totaux-livraisons/${totalParDepot ? 1 : 0 }/${totalParBoisType ? 1 : 0 }/${totalParLongueur ? 1 : 0 }/${totalDateDebut}/${totalDateFin}`, 10000);
	}

	public putPaid(livraison: Livraison) {
		return this.put(`/${livraison.id}/paid`);
	}

	public putFacture(livraison: Livraison) {
		return this.put(`/${livraison.id}/facture`);
	}
}